// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"Search_searchContainer__YFItO","icon":"Search_icon__28jj3","input":"Search_input__1Ph94","searchDropdownOuter":"Search_searchDropdownOuter__1GEjZ"};